import { Component, type ReactNode } from "react";

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div className="min-h-screen bg-[#F4F7FB] flex flex-col items-center justify-center text-center px-4">
            <div className="w-16 h-16 flex items-center justify-center bg-red-100 rounded-full mb-6">
              <i className="ri-error-warning-line text-red-500 text-3xl" />
            </div>
            <h2 className="text-xl font-semibold text-[#0B1F3A] mb-2" style={{ fontFamily: "'Sora', sans-serif" }}>
              Algo salió mal
            </h2>
            <p className="text-slate-500 text-sm max-w-md mb-6">
              Hubo un error al cargar este artículo. Por favor, vuelve a intentarlo.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-3 bg-[#0B1F3A] text-white rounded-xl text-sm font-semibold cursor-pointer whitespace-nowrap"
            >
              Recargar página
            </button>
          </div>
        )
      );
    }

    return this.props.children;
  }
}